const { REACT_APP_CLOUDINARY_CLOUD_NAME, REACT_APP_CLOUDINARY_ADMIN_UPLOAD_PRESET, REACT_APP_CLOUDINARY_CUSTOMER_UPLOAD_PRESET, REACT_APP_CLOUDINARY_SHOPPER_UPLOAD_PRESET, REACT_APP_CLOUDINARY_UPLOAD_PRESET, REACT_APP_CLOUDINARY_GLOBAL_UPLOAD_PRESET, REACT_APP_CLOUDINARY_VENDOR_UPLOAD_PRESET } = process.env;
export const CLOUDINARY_CLOUD_NAME = REACT_APP_CLOUDINARY_CLOUD_NAME;
export const CLOUDINARY_UPLOAD_PRESET = REACT_APP_CLOUDINARY_UPLOAD_PRESET; // Default preset for product uploads
export const CLOUDINARY_ADMIN_UPLOAD_PRESET = REACT_APP_CLOUDINARY_ADMIN_UPLOAD_PRESET;
export const CLOUDINARY_GLOBAL_UPLOAD_PRESET = REACT_APP_CLOUDINARY_GLOBAL_UPLOAD_PRESET;
export const CLOUDINARY_CUSTOMER_UPLOAD_PRESET = REACT_APP_CLOUDINARY_CUSTOMER_UPLOAD_PRESET; 
export const CLOUDINARY_SHOPPER_UPLOAD_PRESET = REACT_APP_CLOUDINARY_SHOPPER_UPLOAD_PRESET;
export const CLOUDINARY_VENDOR_UPLOAD_PRESET = REACT_APP_CLOUDINARY_VENDOR_UPLOAD_PRESET;

// Unsigned upload — only the cloud name and a preconfigured upload preset are
// needed. Cloudinary's API key/secret are for signed, server-side requests and
// must never be shipped to the browser.
export const uploadToCloudinary = async (file, preset = CLOUDINARY_UPLOAD_PRESET) => {
  if (!REACT_APP_CLOUDINARY_CLOUD_NAME || !preset) {
    throw new Error("Cloudinary is not configured: missing cloud name or upload preset.");
  }

  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", preset);

  const response = await fetch(`https://api.cloudinary.com/v1_1/${REACT_APP_CLOUDINARY_CLOUD_NAME}/image/upload`, {
    method: "POST",
    body: formData,
  });

  if (!response.ok) {
    throw new Error("Cloudinary upload failed");
  }

  return response.json();
};
